import { ApiOutlined } from '@ant-design/icons';
import { Button, Card, Col, Empty, Popconfirm, Row, Tooltip } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAssigned } from '@client/store/assigned.store';
import { useDirty } from '@client/store/dirty.store';
import { useLoading } from '@client/store/loading.store';
import { useLocale } from '@client/store/locale.store';
import { flexLayout } from '@client/utils/layout.util';
import { type ECurrency, type IFeature } from '@common/types';
import { numberToCurrency } from '@common/utils';

import styles from '../subscriptions.module.less';

type TSubscriptionFeaturesProps = {
  disabled?: boolean;
};

export const SubscriptionFeatures: React.FC<TSubscriptionFeaturesProps> = (
  props,
) => {
  const { t } = useTranslation();
  const { loading } = useLoading();
  const { setDirty } = useDirty();
  const { locale } = useLocale();

  const { assigned: assignedFeatures, setAssigned: setAssignedFeatures } =
    useAssigned<IFeature>();

  const { disabled = false } = props;

  const unAssign = (feature: IFeature) => {
    setAssignedFeatures(assignedFeatures.filter((f) => f.id !== feature.id));
    setDirty(true);
  };

  return (
    <>
      <Row gutter={[24, 24]}>
        {assignedFeatures.length ? (
          assignedFeatures?.map((feature) => (
            <Col
              key={feature.id}
              {...flexLayout.thirdColumn}
              className={styles.featureCards}
            >
              <Card
                loading={loading}
                hoverable
                variant={'outlined'}
                extra={
                  <Button
                    icon={<ApiOutlined />}
                    color="danger"
                    variant="filled"
                    loading={loading}
                    disabled={disabled}
                  >
                    <Popconfirm
                      title={t('subscription.msg.unAssignConfirm')}
                      disabled={disabled}
                      placement="topLeft"
                      onConfirm={() => {
                        unAssign(feature);
                      }}
                    >
                      {t('actions.unAssign')}
                    </Popconfirm>
                  </Button>
                }
                title={<Tooltip title={feature.title}>{feature.title}</Tooltip>}
              >
                <p>
                  {numberToCurrency(
                    feature.price.originalPrice,
                    locale,
                    feature.price.currency as ECurrency,
                  )}
                </p>
                <p>{feature.description}</p>
              </Card>
            </Col>
          ))
        ) : (
          <Col span={24}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </Col>
        )}
      </Row>
    </>
  );
};
